(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["henderson-opening"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ho-launch-countdown')) {
  customElements.define('ho-launch-countdown', class extends HTMLElement {
    connectedCallback() {
      this.deadline = Date.parse(this.dataset.launchAt);
      this.clock = this.querySelector('[role="timer"]');
      this.numbers = ['days', 'hours', 'minutes', 'seconds'].map(unit => this.querySelector('[data-unit="' + unit + '"]'));
      if (!Number.isFinite(this.deadline) || !this.clock || this.numbers.some(node => !node)) return;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.tick();
      if (Date.now() < this.deadline) this.interval = window.setInterval(() => this.tick(), 1000);
    }
    tick() {
      const remaining = Math.max(0, Math.ceil((this.deadline - Date.now()) / 1000));
      const values = [Math.floor(remaining / 86400), Math.floor(remaining % 86400 / 3600), Math.floor(remaining % 3600 / 60), remaining % 60];
      this.numbers.forEach((node, index) => {
        const value = String(values[index]).padStart(2, '0');
        if (node.textContent !== value) {
          node.textContent = value;
          if (this.ready && !this.reducedMotion.matches && node.animate) node.animate([{opacity: .55, transform: 'translateY(-3px)'}, {opacity: 1, transform: 'translateY(0)'}], {duration: 240, easing: 'ease-out'});
        }
      });
      this.clock.hidden = remaining === 0;
      this.ready = true;
      if (remaining === 0 && this.interval) window.clearInterval(this.interval);
    }
    disconnectedCallback() { if (this.interval) window.clearInterval(this.interval); }
  });
}

  } catch(e) { console.error(e); }
})();
})();
